export default __webpack_public_path__ + "static/media/microscope-green.3462884f.svg";